import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38f9e217")

_pushScopeId("data-v-38f9e217")
const _hoisted_1 = { class: "txt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "no-data",
    style: { height: _ctx.height }
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.txt), 1)
  ], 4))
})